import { Component, OnInit } from '@angular/core';
import { Empresa } from 'app/interfaces/enum/empresas';
import { Usuario } from 'app/interfaces/usuario';
import { SessionStorageService } from 'app/utils/session-storage.service';
import { UsuarioLinkBi } from 'app/interfaces/usuarioLinkBi';
import { MessageService } from 'app/utils/toastr-custom/message.service';
import handleErrorMessage from 'app/utils/error-message-handler';
import { MoedaTaxa } from 'app/interfaces/moeda-taxa';
import { ParceiroNegocio } from 'app/interfaces/parceiro-negocio';
import { HomeContaVendedor } from 'app/interfaces/home-conta-vendedor';
import { HomeProcessoVendedor } from 'app/interfaces/home-processo-vendedor';
import { HomeOportunidadeOfertasVendedor } from 'app/interfaces/home-oportunidade-ofertas-vendedor copy';
import { PeriodoFiltroDashboard } from 'app/interfaces/enum/periodo-filtro-dashboard';
import { UsuarioHttpService } from 'app/main/usuario/usuario-http.service';
import { MoedaTaxaHttpService } from 'app/main/moeda/moedataxa-http.service';
import { ParceiroHttpService } from 'app/main/parceiro/parceiro-http.service';
import { ProcessoHttpService } from 'app/main/processo/processo-http.service';
import { ParametroHttpService } from 'app/main/parametro/parametro-http.service';
import { OportunidadeOfertaHttpService } from 'app/main/oportunidadeoferta/oportunidadeoferta-http.service';

@Component({
  selector: 'app-home-agenciamento-carga-padrao',
  templateUrl: './home-agenciamento-carga-padrao.component.html',
  styleUrls: ['./home-agenciamento-carga-padrao.component.scss'],
})
export class HomeAgenciamentoCargaPadraoComponent implements OnInit {
  usuario: Usuario;
  links = [] as UsuarioLinkBi[];
  parceiroNegocio: ParceiroNegocio;
  contas: HomeContaVendedor;
  moedasTaxas = [] as MoedaTaxa[];
  dataHoje: Date = new Date();
  labelPeriodoProcesso = 'Últimos 30 dias';
  labelPeriodoOferta = 'Últimos 30 dias';
  periodoFiltro = PeriodoFiltroDashboard;
  semDadosOferta: boolean = false;
  semDadosProcesso: boolean = false;
  isTextVisible: boolean = false;
  razaoSocial: string;
  statusOrdemProcesso = ['EM_ANDAMENTO', 'AGUARDANDO_EMBARQUE', 'EMBARCADO', 'DESEMBARCADO', 'FINALIZADO_OPERACIONALMENTE', 'AUDITADO'];
  statusOrdemOfertas = ['APROVADO', 'REPROVADO', 'P2', 'AGUARDANDO_PRICING', 'AGUARDANDO_PARCEIRO', 'PRE_PROPOSTA', 'OFERTA_DISPONIVEL_PARA_ENVIO'];

  constructor(
    _sessionStorageService: SessionStorageService,
    private _usuarioHttpService: UsuarioHttpService,
    private _messageService: MessageService,
    private _parametroHttpService: ParametroHttpService,
    private _moedaTaxaHttpService: MoedaTaxaHttpService,
    private _parceiroHttpService: ParceiroHttpService,
    private _processoHttpService: ProcessoHttpService,
    private _oportunidadeOfertaHttpService: OportunidadeOfertaHttpService
  ) {
    this.usuario = JSON.parse(_sessionStorageService.getItem('user'));
  }

  /**
   * On init
   */
  ngOnInit() {
    this.getLinkBi();
    this.getPtaxMoeda();
    this.getParceiroNegocioByUsuarioId();
  }

  filtroPeriodoOfertas(dias: number) {
    this.labelPeriodoOferta = `Últimos ${dias} dias`;
    const hojeOferta = new Date();
    const inicioOferta = new Date();
    inicioOferta.setDate(hojeOferta.getDate() - dias);
    const dataInicialOferta = inicioOferta.toISOString().substring(0, 10);
    const dataFinalOferta = hojeOferta.toISOString().substring(0, 10);

    this.getInformacaoGraficoOportunidadeOfertasVendedor(this.parceiroNegocio.parceiroNegocioId, dataInicialOferta, dataFinalOferta);
  }
  filtroPeriodoProcesso(dias: number) {
    this.labelPeriodoProcesso = `Últimos ${dias} dias`;
    const hojeProcesso = new Date();
    const inicioProcesso = new Date();
    inicioProcesso.setDate(hojeProcesso.getDate() - dias);
    const dataInicialProcesso = inicioProcesso.toISOString().substring(0, 10);
    const dataFinalProcesso = hojeProcesso.toISOString().substring(0, 10);

    this.getInformacaoGraficoProcessoVendedor(this.parceiroNegocio.parceiroNegocioId, dataInicialProcesso, dataFinalProcesso);
  }

  getPorcentagemVenda() {
    this._parametroHttpService.getParametroByName('PARAM_RAZAO_SOCIAL').subscribe({
      next: result => {
        this.razaoSocial = result.valor;
      },
      error: error => {
        handleErrorMessage(this._messageService, error);
      },
    });
  }

  getLinkBi() {
    this._usuarioHttpService.getLinkBi(this.usuario.usuId).subscribe({
      next: result => {
        this.links = result;
      },
      error: error => {
        handleErrorMessage(this._messageService, error);
      },
    });
  }

  toggleTextVisibility() {
    this.isTextVisible = !this.isTextVisible;
  }

  get empresa() {
    return Empresa;
  }

  getPtaxMoeda() {
    const dataHoje = new Date().toISOString().split('T')[0]; // "2025-10-20"

    this._moedaTaxaHttpService.getPtaxBrlByData(dataHoje).subscribe({
      next: result => {
        if (result && result.length > 0) {
          this.moedasTaxas = result;
        }
      },
      error: error => {
        handleErrorMessage(this._messageService, error);
      },
    });
  }

  getFatorPorSimbolo(simbolo: string): number | undefined {
    return this.moedasTaxas.find(m => m.moedaOrigem?.simboloBacen === simbolo)?.fator;
  }

  getInformacaoGraficoContaVendedor(vendedorId: number) {
    this._parceiroHttpService.getInformacaoGraficoContaVendedor(vendedorId).subscribe({
      next: (result: HomeContaVendedor) => {
        this.radialChart.series = [result.percentualContasAtendidas];
        this.contas = result;
      },
      error: error => handleErrorMessage(this._messageService, error),
    });
  }
  getInformacaoGraficoProcessoVendedor(vendedorId: number, dataInicial?: string, dataFinal?: string) {
    this._processoHttpService.getInformacaoGraficoProcessoVendedor(vendedorId, dataInicial, dataFinal).subscribe({
      next: (result: HomeProcessoVendedor[]) => {
        const mapa = new Map(result.map(item => [item.status, item.quantidade ?? 0]));
        this.donutChart.series = this.statusOrdemProcesso.map(status => mapa.get(status) ?? 0);
        // Verifica se todos os valores são 0
        this.semDadosProcesso = this.donutChart.series.every(v => v === 0);
      },
      error: error => handleErrorMessage(this._messageService, error),
    });
  }
  getInformacaoGraficoOportunidadeOfertasVendedor(vendedorId: number, dataInicial?: string, dataFinal?: string) {
    this._oportunidadeOfertaHttpService.getInformacaoGraficoOportunidadeOfertasVendedor(vendedorId, dataInicial, dataFinal).subscribe({
      next: (result: HomeOportunidadeOfertasVendedor[]) => {
        const mapa = new Map(result.map(item => [item.status, item.quantidade ?? 0]));
        this.donutChartDois.series = this.statusOrdemOfertas.map(status => mapa.get(status) ?? 0);
        // Verifica se todos os valores são 0
        this.semDadosOferta = this.donutChartDois.series.every(v => v === 0);
      },
      error: error => handleErrorMessage(this._messageService, error),
    });
  }

  getParceiroNegocioByUsuarioId() {
    this._parceiroHttpService.getparceiroByUsuarioId(this.usuario.usuId, this.usuario.empresa.empId).subscribe({
      next: (result: ParceiroNegocio) => {
        this.parceiroNegocio = result;
        // TODO: Validar se tem função vendedor

        this.getInformacaoGraficoContaVendedor(result.parceiroNegocioId);
        this.getInformacaoGraficoProcessoVendedor(result.parceiroNegocioId);
        this.getInformacaoGraficoOportunidadeOfertasVendedor(result.parceiroNegocioId);
      },
      error: error => handleErrorMessage(this._messageService, error),
    });
  }

  //GRAFICO CONTROLE DE CONTAS
  radialChart: any = {
    series: [],
    chart: {
      height: 250,
      type: 'radialBar',
      sparkline: { enabled: true },
    },
    plotOptions: {
      radialBar: {
        startAngle: -125,
        endAngle: 125,
        track: {
          background: 'transparent',
          strokeWidth: '100%',
        },
        hollow: {
          margin: 0,
          size: '85%',
          background: 'transparent',
        },
        dataLabels: {
          show: true,
          name: {
            show: true,
            offsetY: 35,
            color: '#6e6b7b',
            fontSize: '14px',
            text: 'Contas Completas',
          },
          value: {
            show: true,
            fontSize: '28px',
            fontWeight: 'bold',
            color: '#6e6b7b',
            offsetY: -10,
            formatter: (val: number) => val.toFixed(0) + '%',
          },
        },
      },
    },
    stroke: {
      dashArray: 5,
      lineCap: 'round',
    },
    colors: ['#7367F0'],
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'horizontal',
        gradientToColors: ['#FF9F43'],
        stops: [0, 100],
      },
    },
    labels: ['Contas Completas'],
  };

  //GRAFICO PROCESSO
  donutChart: any = {
    series: [],
    chart: {
      type: 'donut',
      height: 370,
    },
    labels: ['Em andamento', 'Aguardando Embarque', 'Embarcado', 'Desembarcado', 'Finalizado operacionalmente', 'Auditado'],
    colors: [
      '#0F62AC', // .text-primary / .badge-light-primary (#7367F0)
      '#00CFE8', // .text-success / .bg-success (#28C76F)
      '#28C76F', // .text-warning / .badge-light-warning (#FF9F43)
      '#FF9F43', // .text-danger / .badge-light-danger (#EA5455)
      '#82868B', // .text-info / .badge-light-info (#00CFE8)
      '#512DA8', // .badge-light-secondary (#888888)
    ],
    legend: {
      position: 'bottom',
      horizontalAlign: 'center',
      fontSize: '12px',
      formatter: function (seriesName: string, opts: any) {
        const value = opts.w.globals.series[opts.seriesIndex];
        return `${seriesName}: ${value}`;
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val: number) {
        return val.toFixed(0) + '%';
      },
    },
    tooltip: {
      y: {
        formatter: function (val: number) {
          return val;
        },
      },
    },
  };

  //GRAFICO OFERTA
  donutChartDois: any = {
    series: [],
    chart: {
      type: 'donut',
      height: 350,
    },
    labels: ['Aprovado', 'Reprovado', 'P2', 'Aguardando Pricing', 'Aguardando Parceiro', 'Pré Proposta', 'Oferta Disponível para Envio'],
    colors: [
      '#001F4D', // azul muito escuro, frio
      '#003A80', // azul escuro forte
      '#0052B8', // azul intenso profundo
      '#006FE6', // azul forte
      '#1549A5', // azul vivo intenso
      '#3B88D1', // azul médio forte, mais escuro que
      '#5C9FD6', // azul claro vibrante, mais escuro que
      '#0D57FF', // azul claro forte, mais “quente” dentro do espectro azul
    ],
    legend: {
      position: 'bottom',
      horizontalAlign: 'center',
      fontSize: '12px',
      formatter: function (seriesName: string, opts: any) {
        const value = opts.w.globals.series[opts.seriesIndex];
        return `${seriesName}: ${value}`;
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val: number) {
        return val.toFixed(0) + '%';
      },
    },
    tooltip: {
      y: {
        formatter: function (val: number) {
          return val;
        },
      },
    },
    stroke: {
      width: 0,
    },
  };
}
